import React, {useState} from 'react';
import {makeStyles, useMediaQuery, useTheme} from "@material-ui/core";
import Logo from "../images/cremosso-logo.png"
import {FaTimes} from "react-icons/fa";
import {GiHamburgerMenu} from "react-icons/gi";
import navStripe from "../images/nav_mobile_str.png";
import {Link} from 'react-scroll';
import {Link as LinkDom} from 'react-router-dom';
//import AppSupport from "./AppSupport";
import {MenuItem} from "../App";
import cremossoLogo from "../images/cremosso-logo.png";


const useMenuStyles = makeStyles(theme => ({
    meniuDefault: {
        position: 'fixed',
        width: '100%',
        color: '#fff',
        zIndex: 9999,
        top: 0,
        left: 0,
        right: 0,
        textAlign: 'center',
        padding: '5px',
        cursor: 'pointer',
        //textTransform: 'uppercase',
        transition: 'background 0.2s ease-in-out',
        [theme.breakpoints.only("xs")]: {
            position: 'relative',
            padding: '1rem 1rem .5rem 1rem',
        },
        '&.navigating': {
            background: '#021938',
            transition: 'background 0.2s ease-in-out',
            [theme.breakpoints.only("xs")]: {
                position: 'fixed',
            },
        },

    },
    menuItem: {
        fontWeight: 'bold',
        fontFamily: 'CentraleSansXBold',
        margin: '0 10px',
        color: '#fff',
        display: 'inline-block',
        '&:hover': {
            color: '#FFD85D'
        }

    },
    menuItemActive: {
        color: '#FFD85D'
    },
    navStripeImg: {
        width: '100%',
        margin: 0,
        marginTop: '-1px'
    },
    anchor_link: {
        color: '#fff',
        textDecoration: 'none',
        '&:hover': {
            color: '#FFD85D'
        }
    }

}))


function Menu(props: { [key: string]: any, isHomePage: boolean }) {

    const classes = useMenuStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.only('xs'));

    let links: { name: string, url: string, id: string, offset: number }[] = props.links || [];
    let navigating = props.navigating || false;
    const [isMenuVisible, setIsMenuVisible] = React.useState(false)
    const [checkedInput, setCheckedInput] = useState(false);


    return <>
        {isMobile ?
            <div id={'meniu'} className={`${classes.meniuDefault} ${navigating ? 'navigating' : ''}`}>
                <img src={Logo} className="logo_menu_img" alt={''}/>
                <div id="menuArea">

                    <input type="checkbox" id="menuToggle" defaultChecked={checkedInput}
                    />

                    <label className="menuOpen"
                           onClick={() => {
                               setIsMenuVisible(true);
                               setCheckedInput(true)
                           }}>
                        <GiHamburgerMenu/>
                    </label>

                    <div className={`menu menuEffects ${!isMenuVisible ? 'menuHidden' : ''}`}>
                        <div>
                            <label
                                onClick={() => {
                                    setIsMenuVisible(false);
                                    setCheckedInput(false)
                                }}>
                                <FaTimes/>
                            </label>
                            <div className="menuContent">
                                <ul>
                                    {links.map((item: any, key: number) => {
                                        let goto = (e: any) => {
                                            window.history.pushState({}, "",
                                                item.url
                                            );
                                            return (item.hasOwnProperty('goto') && typeof item.goto === "function" ? item.goto : (() => {
                                            })).apply(null, e)
                                        };

                                        return props.isHomePage ? <li
                                            key={key}
                                            onClick={goto}><span
                                            onClick={() => {
                                                setIsMenuVisible(false);
                                                setCheckedInput(false)
                                            }
                                            }
                                        >{item.name}</span></li> : <li  key={`li-${key}`}>
                                            <LinkDom
                                                to={`/${item.url}`}
                                                className={classes.anchor_link}
                                            >{item.name}</LinkDom>
                                        </li>
                                    })}

                                </ul>
                            </div>

                        </div>
                        <div><img src={navStripe} className={classes.navStripeImg} alt={''}/></div>
                    </div>
                </div>


            </div> :
            <div id={'meniu'} className={`${classes.meniuDefault} ${navigating ? 'navigating' : ''}`}>
                <div className={'menu-cremosso-logo'}>
                    <img src={cremossoLogo} className="" alt={''}/>
                </div>

                {links.map((item: MenuItem, key: number) => {
                    let goto = () => {
                        window.history.pushState({},
                            "",
                            props.isHomePage ? item.url : `/${item.url}`
                        );
                    };

                    return <div
                        className={classes.menuItem}
                        key={key}
                    >{item.targetBlank ?
                        <a className={classes.anchor_link}
                           href={item.url}
                           target={"_blank"}
                           rel={"noreferrer"}>{item.name}</a> :
                        props.isHomePage ? <Link
                            to={item.id}
                            activeClass="activeLink"
                            duration={500}
                            offset={item.offset}
                            onClick={goto}
                            hashSpy={true}
                            smooth={true}
                            spy={true}

                        >
                            {item.name}
                        </Link> : <LinkDom
                            to={`/${item.url}`}
                            className={classes.anchor_link}
                        >{item.name}</LinkDom>

                    }
                    </div>
                })}
            </div>}


    </>

}

export default Menu
